import { useQuery } from "@tanstack/react-query";
import { ApiArrayResponseType } from "types/api.types";
import { axiosInstance } from "utils/axiosInstance";
import { cleanObject } from "utils/cleanObject";

export type Customer = {
  location: Location;
  email: any;
  firstName: string;
  middleName: string;
  lastName: string;
  profileImage: string;
  phoneNumber: string;
  isSuspended: boolean;
  isDeleted: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  id: string;
};

export interface Location {
  type: string;
}

export interface ProductsQueryParams {
  search?: string;
  page?: number;
  limit?: number;
}

export const useGetCustomerQuery = ({
  search,
  page,
  limit,
}: ProductsQueryParams) => {
  const queryParams = new URLSearchParams();

  if (search) queryParams.append("search", search);

  // const url = search ? `/customers?${queryParams.toString()}` : '/customers';

  return useQuery({
    queryKey: ["useGetCustomerQuery", queryParams.toString(), page, limit],
    queryFn: () =>
      axiosInstance
        .get<ApiArrayResponseType<Customer>>("/customers", {
          params: cleanObject({ search, page, limit }),
        })
        .then((res) => res.data),
  });
};
